import React from 'react';
import { useStoreState } from 'easy-peasy';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { PRODUCT } from '../../../models/websiteTypesConstants';


function Security() {

    const productSettings = useStoreState(state => state.siteSettingsModel.productSettings);
    const brandSettings = useStoreState(state => state.siteSettingsModel.brandSettings);
    
    const boldIf = (element, bold) => (bold ? (<b>{element}</b>) : element)

    return (
        <div id="add-on-security" className="add-ons-section">
            <div className="col-lg-12">
                <h2><b>Security People Can Rely On</b></h2>
            </div>
            <div className="col-lg-12">
                <h4>
                    <FontAwesomeIcon icon={faLock} />&nbsp;
                    <span  style={(brandSettings.ProductName === PRODUCT.Grand.bank ? {color: "black"} : {})}>
                        This is a secure site.
                    </span>
                </h4>
            </div>
            <div className="col-lg-12">
                <p className='font16'><b>Ways we protect you and your information:</b></p>
                <p className='font16'>
                    We use 256-bit encryption technology to protect your personal information when you’re using our site or apps.
                    You’ll know your information is fully encrypted when the URL of the page you’re on starts with “https://” and
                    you see a lock symbol in your web browser.
                </p>
                <p className='font16'>
                    <a href={productSettings.PrivacyUrl} target="_blank" rel="noopener noreferrer">
                        {boldIf("See Privacy Policy", brandSettings.ProductName === PRODUCT.Grand.bank)}
                    </a>
                </p>
            </div>
        </div>
    );
}

export default Security;